// R₿L Payments i18n — separate module to avoid touching shadow-fases.js
export const RBL_PAY_I18N = {
  es: {
    pay_with_or: "— o paga con —",
    pay_with_rbl: "🪙 Pagar con R₿L",
    rbl_price_label: "Precio actual",
    rbl_balance: "Tu balance",
    rbl_updated_ago: "Actualizado hace {n}s",
    rbl_updated_just: "Actualizado ahora mismo",
    rbl_loading_price: "Cargando precio…",
    rbl_unavailable: "Pago en R₿L no disponible temporalmente.",
    rbl_unavailable_sub: "DexScreener no responde. Usa la opción en €.",
    rbl_pay_btn: "Pagar {n} R₿L",
    rbl_insufficient: "Te faltan {n} R₿L",
    rbl_get_more: "Conseguir R₿L →",
    rbl_processing: "Procesando…",
    rbl_confirm_title: "Confirmar pago R₿L",
    rbl_confirm_sub: "Vas a gastar {rbl} R₿L (≈ €{eur}). Esta acción es irreversible.",
    rbl_confirm_btn: "Confirmar",
    rbl_cancel: "Cancelar",
    rbl_success_pro: "🎉 PRO activado con R₿L",
    rbl_success_sub: "✓ Suscripción R₿L activa",
    rbl_tab_eur: "💶 Stripe — €{n}/mes",
    rbl_tab_rbl: "🪙 R₿L — {n} R₿L/mes",
    rbl_renewal_note: "Renovación automática cada 30 días desde tu balance R₿L.",
    rbl_login_first: "Inicia sesión",
  },
  en: {
    pay_with_or: "— or pay with —",
    pay_with_rbl: "🪙 Pay with R₿L",
    rbl_price_label: "Current price",
    rbl_balance: "Your balance",
    rbl_updated_ago: "Updated {n}s ago",
    rbl_updated_just: "Updated just now",
    rbl_loading_price: "Loading price…",
    rbl_unavailable: "R₿L payment temporarily unavailable.",
    rbl_unavailable_sub: "DexScreener is not responding. Use the EUR option.",
    rbl_pay_btn: "Pay {n} R₿L",
    rbl_insufficient: "You need {n} more R₿L",
    rbl_get_more: "Get R₿L →",
    rbl_processing: "Processing…",
    rbl_confirm_title: "Confirm R₿L payment",
    rbl_confirm_sub: "You will spend {rbl} R₿L (≈ €{eur}). This is irreversible.",
    rbl_confirm_btn: "Confirm",
    rbl_cancel: "Cancel",
    rbl_success_pro: "🎉 PRO activated with R₿L",
    rbl_success_sub: "✓ R₿L subscription active",
    rbl_tab_eur: "💶 Stripe — €{n}/mo",
    rbl_tab_rbl: "🪙 R₿L — {n} R₿L/mo",
    rbl_renewal_note: "Auto-renews every 30 days from your R₿L balance.",
    rbl_login_first: "Sign in",
  },
  sk: {
    pay_with_or: "— alebo zaplať s —",
    pay_with_rbl: "🪙 Zaplatiť v R₿L",
    rbl_price_label: "Aktuálna cena",
    rbl_balance: "Tvoj balance",
    rbl_updated_ago: "Aktualizované pred {n}s",
    rbl_updated_just: "Práve aktualizované",
    rbl_loading_price: "Načítavam cenu…",
    rbl_unavailable: "Platba v R₿L dočasne nedostupná.",
    rbl_unavailable_sub: "DexScreener neodpovedá. Použi platbu v €.",
    rbl_pay_btn: "Zaplatiť {n} R₿L",
    rbl_insufficient: "Chýba ti {n} R₿L",
    rbl_get_more: "Získať R₿L →",
    rbl_processing: "Spracovanie…",
    rbl_confirm_title: "Potvrdiť platbu R₿L",
    rbl_confirm_sub: "Minieš {rbl} R₿L (≈ €{eur}). Akcia je nezvratná.",
    rbl_confirm_btn: "Potvrdiť",
    rbl_cancel: "Zrušiť",
    rbl_success_pro: "🎉 PRO aktivovaný v R₿L",
    rbl_success_sub: "✓ Predplatné R₿L aktívne",
    rbl_tab_eur: "💶 Stripe — €{n}/mes.",
    rbl_tab_rbl: "🪙 R₿L — {n} R₿L/mes.",
    rbl_renewal_note: "Automatická obnova každých 30 dní z tvojho R₿L balansu.",
    rbl_login_first: "Prihlásiť sa",
  },
  "zh-CN": {
    pay_with_or: "— 或使用 —",
    pay_with_rbl: "🪙 使用 R₿L 支付",
    rbl_price_label: "当前价格",
    rbl_balance: "您的余额",
    rbl_updated_ago: "{n}秒前更新",
    rbl_updated_just: "刚刚更新",
    rbl_loading_price: "正在加载价格…",
    rbl_unavailable: "R₿L 支付暂时不可用。",
    rbl_unavailable_sub: "DexScreener 无响应。请使用 € 选项。",
    rbl_pay_btn: "支付 {n} R₿L",
    rbl_insufficient: "您还需要 {n} R₿L",
    rbl_get_more: "获取 R₿L →",
    rbl_processing: "处理中…",
    rbl_confirm_title: "确认 R₿L 支付",
    rbl_confirm_sub: "您将消费 {rbl} R₿L（≈ €{eur}）。此操作不可撤销。",
    rbl_confirm_btn: "确认",
    rbl_cancel: "取消",
    rbl_success_pro: "🎉 已使用 R₿L 激活 PRO",
    rbl_success_sub: "✓ R₿L 订阅已激活",
    rbl_tab_eur: "💶 Stripe — €{n}/月",
    rbl_tab_rbl: "🪙 R₿L — {n} R₿L/月",
    rbl_renewal_note: "每30天从您的 R₿L 余额自动续订。",
    rbl_login_first: "请先登录",
  },
  de: {
    pay_with_or: "— oder zahle mit —",
    pay_with_rbl: "🪙 Mit R₿L bezahlen",
    rbl_price_label: "Aktueller Preis",
    rbl_balance: "Dein Guthaben",
    rbl_updated_ago: "Aktualisiert vor {n}s",
    rbl_updated_just: "Gerade aktualisiert",
    rbl_loading_price: "Preis wird geladen…",
    rbl_unavailable: "R₿L-Zahlung vorübergehend nicht verfügbar.",
    rbl_unavailable_sub: "DexScreener antwortet nicht. Nutze die €-Option.",
    rbl_pay_btn: "{n} R₿L bezahlen",
    rbl_insufficient: "Dir fehlen {n} R₿L",
    rbl_get_more: "R₿L holen →",
    rbl_processing: "Verarbeitung…",
    rbl_confirm_title: "R₿L-Zahlung bestätigen",
    rbl_confirm_sub: "Du wirst {rbl} R₿L (≈ €{eur}) ausgeben. Diese Aktion ist unwiderruflich.",
    rbl_confirm_btn: "Bestätigen",
    rbl_cancel: "Abbrechen",
    rbl_success_pro: "🎉 PRO mit R₿L aktiviert",
    rbl_success_sub: "✓ R₿L-Abo aktiv",
    rbl_tab_eur: "💶 Stripe — €{n}/Monat",
    rbl_tab_rbl: "🪙 R₿L — {n} R₿L/Monat",
    rbl_renewal_note: "Automatische Verlängerung alle 30 Tage von deinem R₿L-Guthaben.",
    rbl_login_first: "Melde dich an",
  },
};

const _fmt = (s, p) => {
  if (!p) return s;
  return Object.keys(p).reduce((a, k) => a.replace(new RegExp(`\\{${k}\\}`, "g"), p[k]), s);
};

export const tRbl = (lang, key, params) => {
  const d = RBL_PAY_I18N[lang] || RBL_PAY_I18N.es;
  return _fmt(d[key] || RBL_PAY_I18N.es[key] || key, params);
};

export default RBL_PAY_I18N;
